import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { MajorBrowseItem, SearchMajorsFilters } from '../types';

export const useAgentContext = (
  filters: SearchMajorsFilters,
  total: number,
  majors: readonly MajorBrowseItem[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Filter Controls',
    description:
      'Search bar with label and Clear/Search buttons, college type multi-select dropdown with removable filter chips, Sort By dropdown (name, underemployment, rigor, demand, option value, relevance when searching), and Asc/Desc order toggle.',
  });

  useRegisterAgentContext({
    kind: 'nuggetList',
    description: 'Paginated, filterable list of college majors.',
    nuggets: majors.map((m) => ({
      id: m.id,
      variant: 'major',
      title: m.name,
      description: m.description,
    })),
    data: {
      searchTerm: filters.search || null,
      collegeFilters: filters.colleges.length > 0 ? filters.colleges : null,
      sortBy: filters.sort,
      sortOrder: filters.order,
      page: filters.page,
      totalResults: total,
    },
  });
};
